export default __webpack_public_path__ + "static/media/Lapis-Lazuli-Beaded-Diffuser-Stretch-Bracelet.be005a06.jpg";